import type { MouseEventHandler } from 'react'

import { useTranslate } from '../utils/translate'

type WarningMessageProps = {
  message: string
  onDismiss?: MouseEventHandler<HTMLSpanElement>
}

export default function WarningMessage({ message, onDismiss }: Readonly<WarningMessageProps>) {
  const t = useTranslate('interface')

  return (
    <p className="ep-notification-warning">
      {message}
      {onDismiss && (
        <span
          title={t('components.warningMessageComponent.dismissButton.label')}
          className="ep-simple-notification-close"
          onClick={onDismiss}
        />
      )}
    </p>
  )
}
